import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';
import {put, takeLatest, select, take, call} from 'redux-saga/effects';

import {selectEnv} from 'reducers/env';
import {getInvite, selectInvite} from 'api/invite';

import {goAfterLogin} from 'utils/AuthService';

const namespace = 'flows/interest/invite';

// Actions
const LOAD_INTEREST_INVITE = defineAction('LOAD_INTEREST_INVITE', namespace);
const SUBMIT_INTEREST_INVITE = defineAction('SUBMIT_INTEREST_INVITE', namespace);

export const loadInterestInvite = createAction(LOAD_INTEREST_INVITE.ACTION);
export const submitInterestInvite = createAction(SUBMIT_INTEREST_INVITE.ACTION);

// Interest Invite Saga
export function* interestInviteSaga({payload}) {
  const {id} = payload;

  // Get the invite when the page loads
  // TODO: skip this page if already logged in
  yield put(getInvite({id: payload.id}));

  // Wait for the user to click the login link
  yield take(SUBMIT_INTEREST_INVITE.ACTION);

  // Take them to the login page, with a post-login redirect
  const env = yield select(selectEnv);
  const {deal: {self: deal}, self: invite} = (yield select(selectInvite, id)).data;
  if (env.web) {
    const after = btoa('/interest/confirm');
    // Carry on after login, passing guest = true
    yield call(goAfterLogin, `/interest${deal}${invite}/after/${after}/confirm/no`, true);
    yield call(browserHistory.push, '/login');
  }
}

export function* sagas() {
  yield takeLatest(LOAD_INTEREST_INVITE.ACTION, interestInviteSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/interest/invite/index.js